import { Link } from "react-router-dom";
import WebsiteNavbar from "../components/WebsiteNavbar";
import Footer from "../components/Footer";
import "../style/services.css";
import skipBin from "../images/skipBin.jpeg";
import delivery from "../images/delivery.jpeg";
import waste from "../images/waste.png";
import commercial from "../images/commercial.png";
import recycle from "../images/recycle.png";

const services = [
  {
    id: 1,
    icon: "ti-trash",
    title: "Skip Bin Hire",
    desc: "Bin sizes from 2m³ to 10m³ for projects of any size, with flexible hire periods from 1 to 3 weeks.",
    link: "/booking",
    linkText: "Book Now",
    highlight: true,
    img: skipBin,
  },
  {
    id: 2,
    icon: "ti-truck-delivery",
    title: "Same Day Delivery",
    desc: "Book before 10am and we'll deliver to your door the same day. Fast, reliable and tracked so you know exactly when to expect us.",
    link: "/booking",
    linkText: "Learn More",
    highlight: false,
    img: delivery,
  },
  {
    id: 3,
    icon: "ti-bulldozer",
    title: "Waste Removal",
    desc: "Ideal for large cleanouts and renovation projects. We handle all types of general waste, green waste and mixed loads with responsible disposal.",
    link: "/booking",
    linkText: "Learn More",
    highlight: false,
    img: waste,
  },
  {
    id: 4,
    icon: "ti-building-skyscraper",
    title: "Commercial Hire",
    desc: "Ongoing commercial contracts for builders, developers and facility managers. Custom pricing, priority scheduling and dedicated account management.",
    link: "/commercial",
    linkText: "Get a Quote",
    highlight: false,
    img: commercial,
  },
  {
    id: 5,
    icon: "ti-leaf",
    title: "Recycling Solutions",
    desc: "We sort and divert recyclable materials from landfill wherever possible. Green waste, concrete, timber and metals are all handled responsibly.",
    link: "/contact",
    linkText: "Learn More",
    highlight: false,
    img: recycle,
  },
];

const Services = () => {

 

  return (
    <>
      <WebsiteNavbar />

      <div className="services-page">
        {/* ── Hero ── */}
        <div className="services-layout">
          <div className="services-sidebar">
            <p className="services-eyebrow">What We Offer</p>

            <h1 className="services-sidebar-title">Our Services</h1>

            <p className="services-sidebar-sub">
              More than just skip bins. We provide a complete waste management solution from delivery to responsible disposal.
            </p>

            <Link to="/booking" className="services-sidebar-btn">
              Book a Skip Bin
            </Link>

            <div className="services-divider"></div>

            <div className="services-stats">
              <div className="services-stat">
                <h3>5+</h3>
                <p>Services</p>
              </div>

              <div className="services-stat">
                <h3>500+</h3>
                <p>Bins Delivered</p>
              </div>

              <div className="services-stat">
                <h3>98%</h3>
                <p>On-Time</p>
              </div>
            </div>

            <div className="services-divider"></div>

            {/* <div className="services-nav">
              <div className="services-nav-item">
                <i className="ti ti-check"></i>
                Skip Bin Hire
              </div>

              <div className="services-nav-item">
                <i className="ti ti-check"></i>
                Same Day Delivery
              </div>

              <div className="services-nav-item">
                <i className="ti ti-check"></i>
                Waste Removal
              </div>

              <div className="services-nav-item">
                <i className="ti ti-check"></i>
                Commercial Hire
              </div>

              <div className="services-nav-item">
                <i className="ti ti-check"></i>
                Recycling Solutions
              </div>
            </div> */}
          </div>

          <div className="services-list">
            {services.map((s) => (
              <div
                key={s.id}
                className={`service-row${s.highlight ? " service-row--highlight" : ""}`}
              >
                <div className="service-text">
                  <div className="service-icon-wrap">
                    <i className={`ti ${s.icon}`} />
                  </div>

                  <h2 className="service-title">{s.title}</h2>

                  <p className="service-desc">{s.desc}</p>

                  <Link to={s.link} className="service-link">
                    {s.linkText}

                    <span className="service-link-arrow">→</span>
                  </Link>
                </div>

                <div className="service-img-wrap">
                  <div className="service-img-inner">
                    <img
                      src={s.img}
                      alt={s.title}
                      className="service-img"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                      onLoad={(e) => {
                        e.target.nextSibling.style.display = "none";
                      }}
                    />

                    <div
                      className="service-img-placeholder"
                      style={{ display: "none" }}
                    >
                      <i className={`ti ${s.icon}`} />

                      <p>Add your image here</p>

                      <code>{s.img}</code>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Services;
